import type { ComponentTypesV2 } from 'types/selectComponent'
import BasicFilter from '../basic/BasicFilter'
import type {
  ConfigurableFilterOptionsType,
  FilterComponentNodeV2,
  FilterGenericPropsType,
  FilterValuesType,
} from '../typeV2'
import { parseStringifiedListFilterValue } from '../utils/utils'
import { CABLE_LENGTH_OPTIONS } from './CableLengthFilter'

export const CABLE_LENGTH_FILTER_KEY_V2 = 'cable_length'

export const isCableLengthFilterAvailableV2 = (filterValues: FilterValuesType) => {
  const types = parseStringifiedListFilterValue<ComponentTypesV2>({
    filterValues,
    key: 'types',
  })
  return types.has('cable')
}

export const createCableLengthFilterNode = <T,>({
  label = 'Cable Length',
  ...restConfigs
}: ConfigurableFilterOptionsType<string, T>): FilterComponentNodeV2 => {
  const FilterComponent = (filterProps: FilterGenericPropsType) => {
    const isAvailable = isCableLengthFilterAvailableV2(filterProps.allFilterValues)
    if (!isAvailable) {
      return null
    }

    return (
      <BasicFilter
        label={label}
        defaultSelectedOptionValue={''}
        options={CABLE_LENGTH_OPTIONS}
        filterKey={CABLE_LENGTH_FILTER_KEY_V2}
        {...restConfigs}
        {...filterProps}
      />
    )
  }

  return {
    key: CABLE_LENGTH_FILTER_KEY_V2,
    component: FilterComponent,
  }
}

export default createCableLengthFilterNode
